import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({})
export default class AppFooterDisclaimer extends Vue {
  @State(state => state.config.ppfDisclaimerUrl)
  public ppfDisclaimerUrl!: string;
  @State(state => state.config.ppfPrivacyCookiesUrl)
  public ppfPrivacyCookiesUrl!: string;
}
